<template>
  <div
    class="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden hover:shadow-md transition-shadow"
  >
    <!-- En-tête du document -->
    <div class="p-4 bg-white border-b border-gray-200">
      <div class="flex items-start justify-between">
        <div class="flex items-start gap-3 flex-1 min-w-0">
          <div class="shrink-0 mt-1" aria-hidden="true">
            <svg class="w-8 h-8 text-red-500" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"
              />
            </svg>
          </div>
          <div class="flex-1 min-w-0">
            <p
              class="text-sm font-semibold text-gray-900 truncate"
              :title="document.name"
            >
              {{ document.name }}
            </p>
            <p class="text-xs text-gray-500 mt-1">
              {{ document.ext.toUpperCase() }}
            </p>
          </div>
        </div>
        <a
          :href="document.url"
          :download="document.name"
          target="_blank"
          rel="noopener noreferrer"
          class="shrink-0 ml-2 p-2 text-gray-500 hover:text-[#04406E] transition-colors"
          :title="`Télécharger ${document.name}`"
          aria-label="Télécharger le PDF"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
        </a>
      </div>
    </div>

    <!-- Aperçu PDF (carte cliquable) -->
    <button
      type="button"
      class="relative bg-gray-100 aspect-video flex items-center justify-center group cursor-pointer w-full"
      @click="onPreview"
      :aria-label="`Prévisualiser le PDF ${document.name}`"
    >
      <div class="text-center p-4">
        <svg class="w-16 h-16 text-red-500 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24">
          <path
            d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"
          />
        </svg>
        <p class="text-sm text-gray-600">Cliquez pour prévisualiser</p>
      </div>
      <div
        class="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center"
        aria-hidden="true"
      >
        <svg
          class="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
          />
        </svg>
      </div>
    </button>
  </div>
</template>

<script setup lang="ts">
interface AttachmentDocument {
  url: string
  name: string
  ext: string
  type: string
  index: number
}

const props = defineProps<{
  document: AttachmentDocument
}>()

const emit = defineEmits<{
  (e: 'preview-requested', document: AttachmentDocument): void
}>()

const onPreview = () => {
  emit('preview-requested', props.document)
}
</script>

